import { render, staticRenderFns } from "./UploadProductFilesModal.vue?vue&type=template&id=192f9916&scoped=true"
import script from "./UploadProductFilesModal.vue?vue&type=script&lang=js"
export * from "./UploadProductFilesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f9916",
  null
  
)

export default component.exports